<template>
  <section  v-if="profile">

    <b-card no-body class="p-2">
      <section>
        <dl>
          <dt>{{ $t('PROFILE.ADMINISTRATOR') }}</dt>
          <dd>{{ showAdmin() }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('PROFILE.ACTIVE') }}</dt>
          <dd>{{ showState() }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('PROFILE.REGISTERED') }}</dt>
          <dd>{{ $moment(profile.createdDate) | moment("YYYY-MM-DD HH:mm") }}</dd>
        </dl>
        <dl>
          <dt>{{ $t('PROFILE.ACTIVITY') }}</dt>
          <dd>{{ $moment(profile.lastActivity) | moment("YYYY-MM-DD HH:mm") }}</dd>
        </dl>
      </section>

      <template v-slot:footer>      
            <change-picture :profile="profile" v-if="profile.id == user.id" @updatedImage="updatedImage">
              <b-button size="sm">
                <i class="fa fa-image"></i>
                {{ $t('PROFILE.EDIT_IMAGE.TITLE')}}
              </b-button>
            </change-picture>
      </template>

    </b-card>
  </section>
</template>
<script>
import ChangePicture from "./ChangePicture";
export default {
  components: {
    ChangePicture
  },
  props: ["profile"],
  data () {
    return {
      locale: this.$i18n.locale,
      locales: this.$store.getters["lang/locales"],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    updatedImage(imageData) {
      this.$store.dispatch("auth/setProfileImage", imageData);
      this.profile.imageExtension = imageData;
    },
    showEdit() {
      if (this.profile.id == this.user.id) {
        return false;
      }
      if (this.user.superAdmin == 1) {
        return true;
      }
      if (this.user.isAdmin == 1) {
        return true;
      }
      return false;
    },
    showState: function() {
      if (this.profile.state === 0) {
        return this.$t("TEAM.ACTIVE");
      }
      return this.$t("TEAM.INACTIVE");
    },
    showAdmin: function() {
      if (this.profile.isAdmin === 1) {
        return this.$t("YES");
      }
      return this.$t("NO");
    }
  },
  computed: {
    imageUrl: function() {
      if (this.profile.imageExtension == null) {      
        return "/img/default-avatar.png";
      } else {
        return process.env.VUE_APP_BACKEND + "/profile/image/" + this.profile.id + "?date=" + Date.now();
      }
    }
  }
};
</script>
<style>
</style>
